<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()">
  <mat-icon>close</mat-icon>
</button>
@if (companyName) {
  <h1 mat-dialog-title>Fund Tear Sheet - {{ companyName || companyTicker }}</h1>
}
<div mat-dialog-content>
  <app-line-chart
    [series]="closeAdjData"
    [extraOptions]="extraOptions"
  ></app-line-chart>

  <div>
    <h3 class="summary-header">Description</h3>
    @if (incomeDataLoaded) {
      <div class="overflow-hidden">
        <p class="overview-text mt-3">{{ overview["description"] }}</p>
        <div class="info-section">
          @if (resp) {
            <div class="row">
              <div class="col-md-6">
                <div class="info-line" [class.no-info-value]="!resp.isin">
                  <span class="info-title">ISIN</span>
                  <span class="info-value">{{ resp.isin ?? "-" }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.BrandingCompanyName"
                >
                  <span class="info-title">Managing Company</span>
                  <span class="info-value industry-sector">{{
                    resp.BrandingCompanyName ?? "-"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.DomicileName"
                >
                  <span class="info-title">Domicile</span>
                  <span class="info-value industry-sector">{{
                    resp.DomicileName ?? "-"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.BaseCurrency"
                >
                  <span class="info-title">Price Currency</span>
                  <span class="info-value">{{ resp.BaseCurrency }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.GlobalCategoryName"
                >
                  <span class="info-title">Morningstar Category</span>
                  <span class="info-value">{{ resp.GlobalCategoryName }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.EquityStyleBox"
                >
                  <span class="info-title">Morningstar Style</span>
                  <span class="info-value">{{
                    styles[resp.EquityStyleBox]
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.MorningStarRating"
                >
                  <span class="info-title">Morningstar Rating</span>
                  <span class="info-value"
                    >{{ resp.MorningStarRating ?? "-" }}/5</span
                  >
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.LegalStructure"
                >
                  <span class="info-title">Fund Type</span>
                  <span class="info-value">{{
                    resp.LegalStructure ?? "-"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.FundInceptionDate"
                >
                  <span class="info-title">Launch Date</span>
                  <span class="info-value">{{
                    resp.FundInceptionDate ?? "-"
                  }}</span>
                </div>
                <div class="info-line" [class.no-info-value]="!resp.FeeLevel">
                  <span class="info-title">Fee Level</span>
                  <span class="info-value">{{
                    feeLevel[resp.FeeLevel] ?? "-"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="resp.UCITS === undefined"
                >
                  <span class="info-title">UCITS</span>
                  <span class="info-value">{{
                    resp.UCITS == 0 ? "No" : "Yes"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="resp.FundOfFunds === undefined"
                >
                  <span class="info-title">Fund of Funds</span>
                  <span class="info-value">{{
                    resp.FundOfFunds == 0 ? "No" : "Yes"
                  }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.FundTNAVDayEnd"
                >
                  <span class="info-title">AUM</span>
                  <span class="info-value"
                    >{{ resp.FundTNAVDayEnd | number: "1.0-0" }}M$</span
                  >
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="
                    !closeAdjData ||
                    !closeAdjData[0] ||
                    !closeAdjData[0].data ||
                    !closeAdjData[0].data.slice(-1)[0]
                  "
                >
                  <span class="info-title">Price date</span>
                  <span class="info-value">{{
                    closeAdjData &&
                    closeAdjData[0] &&
                    closeAdjData[0].data &&
                    closeAdjData[0].data.slice(-1)[0]
                      ? (closeAdjData[0].data.slice(-1)[0][0]
                        | date: "MMM d, y")
                      : "NA"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="
                    !closeAdjData ||
                    !closeAdjData[0] ||
                    !closeAdjData[0].data ||
                    !closeAdjData[0].data.slice(-1)[0]
                  "
                >
                  <span class="info-title">Last Price</span>
                  <span class="info-value"
                    >{{ resp.BaseCurrency }}
                    {{
                      closeAdjData &&
                      closeAdjData[0] &&
                      closeAdjData[0].data &&
                      closeAdjData[0].data.slice(-1)[0]
                        ? (closeAdjData[0].data.slice(-1)[0][1]
                          | number: "1.2-2")
                        : "NA"
                    }}</span
                  >
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp['52WeekHigh']"
                >
                  <span class="info-title">52 Week High</span>
                  <span class="info-value"
                    >{{ resp.BaseCurrency }}
                    {{
                      resp["52WeekHigh"]
                        ? (resp["52WeekHigh"] | number: "1.2-2")
                        : "NA"
                    }}</span
                  >
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp['52WeekLow']"
                >
                  <span class="info-title">52 Week Low</span>
                  <span class="info-value"
                    >{{ resp.BaseCurrency }}
                    {{
                      resp["52WeekLow"]
                        ? (resp["52WeekLow"] | number: "1.2-2")
                        : "NA"
                    }}</span
                  >
                </div>
                <div class="info-line" [class.no-info-value]="!resp.ReturnM1">
                  <span class="info-title">1 Month return</span>
                  <span class="info-value">{{
                    resp.ReturnM1
                      ? (resp.ReturnM1 | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div class="info-line" [class.no-info-value]="!resp.ReturnM3">
                  <span class="info-title">3 Months return</span>
                  <span class="info-value">{{
                    resp.ReturnM3
                      ? (resp.ReturnM3 | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div class="info-line" [class.no-info-value]="!resp.ReturnM0">
                  <span class="info-title">YTD return</span>
                  <span class="info-value">{{
                    resp.ReturnM0
                      ? (resp.ReturnM0 | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div class="info-line" [class.no-info-value]="!resp.ReturnM12">
                  <span class="info-title">1 Year return</span>
                  <span class="info-value">{{
                    resp.ReturnM12
                      ? (resp.ReturnM12 | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.ReturnM36UA"
                >
                  <span class="info-title">3 Years return</span>
                  <span class="info-value">{{
                    resp.ReturnM36UA
                      ? (resp.ReturnM36UA | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.ReturnM60UA"
                >
                  <span class="info-title">5 Years return</span>
                  <span class="info-value">{{
                    resp.ReturnM60UA
                      ? (resp.ReturnM60UA | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
                <div
                  class="info-line"
                  [class.no-info-value]="!resp.ReturnM120UA"
                >
                  <span class="info-title">10 Years return</span>
                  <span class="info-value">{{
                    resp.ReturnM120UA
                      ? (resp.ReturnM120UA | number: "1.2-2") + "%"
                      : "NA"
                  }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="mt-4">
    <button
      mat-flat-button
      class="float-end"
      color="primary"
      (click)="onNoClick()"
    >
      <span class="navigation-button">Close</span>
    </button>
  </div>
</div>
